import { Component, OnInit, ViewChild, Directive, ElementRef, Input } from '@angular/core';
import * as xml2js from 'xml2js';
import { ItemService } from './invoiceCheck.service';
import { ItemPopupService } from './../invoice-html/item-popup.service';
import { Router, ActivatedRoute } from '@angular/router';
import { SystemSetting } from '../system-setting';
import * as _ from 'lodash';
@Component({
	selector: 'app-invoiceCheck',
	templateUrl: './invoice-check.component.html',
	styleUrls: ['./invoice-check.component.styl']
})
export class InvoiceCheckComponent implements OnInit {
	invoiceMaster: any;
	invoiceDetails: any;
	invoiceBills: any;
	invoiceGifts: any;
	fileXml: string;
	isDiscount: number;
	isMultiTax: number;
	Day: string;
	Month: string;
	Year: string;
	signature: any;
	// resulftVerify: boolean;
	messege: string;
	invoiceXml: any;
	x509IssuerName: any;
	x509SerialNumber: any;
	tempFileUpload: any;
	templateName: any;
	capCha: string;
	capChaRequired: string;
	isValidFile: boolean;
	showInvoice: boolean;
	@ViewChild("xmlfile") xmlFile: any;

	constructor(
		private service: ItemService,
		private itemPopupService: ItemPopupService,
		private router: Router,
	) { }

	ngOnInit() {
		setTimeout(() => {
			this.changeCapCha();
		}, 0);
	}

	changeCapCha() {
		const str = Math.random().toString(36);
		this.capChaRequired = str.substring(str.length - 5, str.length);
		const canvas = <HTMLCanvasElement>document.getElementById('capChaRequired');
		const ctx = canvas.getContext('2d');
		ctx.clearRect(0, 0, canvas.width, canvas.height);
		ctx.font = '400 30px "Segoe UI"';
		ctx.fillStyle = '#fff';
		ctx.fillText(this.capChaRequired, 1, canvas.height / 2 + 8);
		if (this.capChaRequired.length > 5) {
			this.changeCapCha();
		}
	}
	
	openFile(event) {
		//this.waiting.nativeElement.click();
		this.signature = null;
		// this.resulftVerify = false;
		this.x509IssuerName = null;
		this.x509SerialNumber = null;
		const fileSelected = event.target.files[0];
		this.tempFileUpload = fileSelected;
		var reader = new FileReader();
		reader.readAsText(fileSelected);
		reader.onloadend = this.handleCheckFile.bind(this);
	}

	handleCheckFile(readerEvt) {
		var that = this;
		let text = readerEvt.target.result;
		this.fileXml = text;
		xml2js.parseString(text, function (err, item) {
			if (item.UnitInvoiceDataXMLSign != 'undefined' && item.UnitInvoiceDataXMLSign != null && item.UnitInvoiceDataXMLSign != "") {
				that.isValidFile = true;
				that.showInvoice = true;
				that.invoiceMaster = item.UnitInvoiceDataXMLSign.InvoiceDataXML[0].InvoiceData[0];
				that.invoiceDetails = item.UnitInvoiceDataXMLSign.InvoiceDataXML[0].InvoiceDetails[0].InvoiceDetail;
				that.invoiceBills = item.UnitInvoiceDataXMLSign.InvoiceDataXML[0].Bills[0].Bill;
				that.invoiceGifts = item.UnitInvoiceDataXMLSign.InvoiceDataXML[0].Gifts[0].Gift;
				that.signature = item.UnitInvoiceDataXMLSign.Signature;
				// if (that.signature != 'undefined' && that.signature != null && that.signature != '') {
				// 	that.x509IssuerName = that.signature[0].KeyInfo[0].X509Data[0].X509IssuerSerial[0].X509IssuerName[0];
				// 	that.x509SerialNumber = that.signature[0].KeyInfo[0].X509Data[0].X509IssuerSerial[0].X509SerialNumber[0];
				// } 
				// else {
				// 	that.messege = "Hóa đơn chưa được ký số";
				// 	that.isValidFile = true;
				// 	that.showInvoice = true;
				// }
			} 
			else 
			{
				that.messege = "message.fileStructureError";
				that.isValidFile = false;
				that.showInvoice = false;
			}
		});
	}
	mapDetailsInvoice(items: any){
		let that = this;
		for(var i = 0; i < items.length; i++){
			let temp = items[i];
			items[i] = that.mapArray(temp);
		}
		return items;
	}

	mapArray(invoice: any) {
		return _.forOwn(invoice, function (value, key) {
			if (value[0] && !value[1]) {
				invoice[key] = value[0].trim();
			}
		});
	}

	submitFile() {
		if (this.capCha != this.capChaRequired) {
			this.capCha = '';
			this.changeCapCha();
			setTimeout(() => {
				let messageKey = 'message.capChaNotMatch';
				this.router.navigate([{
					outlets: {
						notification: 'notification/' + messageKey
					}
				}], {
						replaceUrl: true
					});
			});
		} else {
			this.capCha = '';
			this.changeCapCha();
			if (this.isValidFile == false && this.showInvoice == false) {
				setTimeout(() => {
					let messageKey = this.messege;
					this.router.navigate([{
						outlets: {
							notification: 'notification/' + messageKey
						}
					}], {
							replaceUrl: true
						});
				});
			} else
				if (this.showInvoice) {
					if (this.invoiceMaster) {
						this.invoiceMaster = this.mapArray(this.invoiceMaster);
						this.invoiceDetails = this.mapDetailsInvoice(this.invoiceDetails);
						if(this.invoiceBills){
							this.invoiceBills = this.mapDetailsInvoice(this.invoiceBills);
						}
						if(this.invoiceGifts){
							this.invoiceGifts = this.mapDetailsInvoice(this.invoiceGifts);
						}
						//this.getInvoiceByXml(this.invoiceMaster.InvoiceNo, this.invoiceMaster.InvoiceSerial, this.invoiceMaster.InvoiceForm);
						this.viewInvoice();
					}
				}
		}
	}

	clickSelectFile() {
		this.invoiceXml = "";
	}

	// getInvoiceByXml(invoiceNo: string, symbol: string, invoiceCode: string) {
	// 	this.service.getInvoiceByInfoXml(invoiceNo, symbol, invoiceCode).subscribe((item) => {
	// 		if (item.data) {
	// 			this.viewInvoice(item.data.Id, item.data.CompanyId);
	// 		}
	// 	});
	// }

	viewInvoice() {
		this.itemPopupService.setDataOfXml(this.invoiceMaster, this.invoiceDetails, this.invoiceBills, this.invoiceGifts, this.tempFileUpload, this.signature);
		this.router.navigate(['/', {
			outlets: { popup: `invoice-html/${0}/${0}` }
		}]);
	}

	// setData(){
	// 	this.itemPopupService.setData(this.tempFileUpload, this.signature, this.x509IssuerName, this.x509SerialNumber);
	// 	//hien thi nut Kiem Tra tai man hinh xem hoa don
	// 	this.itemPopupService.setIsCheckXml(true);
	// }

}

